export function hideMerchandising() {
  const merch = document.querySelectorAll('.ai-merchandising');
  if (merch && merch.length > 0) {
    const iam = document.getElementById('ls-in-app-messages');
    if (iam) {
      iam.classList.add('ls-hide');
    }
    for (let i = 0; i < merch.length; i++) {
      merch[i].classList.add('ls-hide');
    }
  }
}
